module.exports = __webpack_public_path__ + "media/images/amenities_icons/photocopier-5d2c32c23697abc2298d9d5e2fd3b21b.svg";